export enum GtmInsuranceType {
    Transport = 'transport',
}
